import { NgModule, CUSTOM_ELEMENTS_SCHEMA } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { RouterModule } from '@angular/router';
import { IonicModule } from '@ionic/angular';

import { SzamlazoLayoutComponent } from './szamlazo-layout/szamlazo-layout.component';
import { SzamlazoKezdolapComponent } from './kezdolap/kezdolap.component';
import { SzamlakComponent } from './szamlak/szamlak.component';
import { VevokComponent } from './vevok/vevok.component';
import { TermekekComponent } from './termekek/termekek.component';
import { BeallitasokComponent } from './beallitasok/beallitasok.component';
import { KasszaComponent } from './kassza/kassza.component';
import { KintlevosegekComponent } from './kintlevosegek/kintlevosegek.component';
import { ProfilMenuComponent } from '../components/profil-menu/profil-menu.component';
import { UgyfelkorBeallitasComponent } from '../components/ugyfelkor-beallitas/ugyfelkor-beallitas.component';
import { KameraOlvasoComponent } from '../components/kamera-olvaso/kamera-olvaso.component';
import { Ean13KodComponent } from '../components/ean13-kod/ean13-kod.component';
import { NavTechnikaiBeallitasComponent } from '../components/nav-technikai-beallitas/nav-technikai-beallitas.component';
import { SzerkZarSavComponent } from '../components/szerk-zar/szerk-zar-sav.component';

// SZÁMLÁZÓ (SZAMLAZO) – önálló alrendszer a Könyvelés (NAPLO) és a Bér (BER) mellett, saját adattal.
// A routing az app-routing.module-ban. Arculat: rózsapiros (#be123c / #fb7185 / #881337), Fókusz-keret.
@NgModule({
  declarations: [SzamlazoLayoutComponent, SzamlazoKezdolapComponent, SzamlakComponent, VevokComponent, TermekekComponent, BeallitasokComponent, KasszaComponent, KintlevosegekComponent],
  imports: [CommonModule, FormsModule, RouterModule, IonicModule, ProfilMenuComponent, UgyfelkorBeallitasComponent, NavTechnikaiBeallitasComponent, KameraOlvasoComponent, Ean13KodComponent, SzerkZarSavComponent],
  exports: [SzamlazoLayoutComponent, SzamlazoKezdolapComponent, SzamlakComponent, VevokComponent, TermekekComponent, BeallitasokComponent, KasszaComponent, KintlevosegekComponent],
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
})
export class SzamlazoModule {}
